import { render, staticRenderFns } from "./AppAnnouncementDismissMenu.vue?vue&type=template&id=ffe0d8f0&"
import script from "./AppAnnouncementDismissMenu.vue?vue&type=script&lang=ts&"
export * from "./AppAnnouncementDismissMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports